import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "progress-bar-generic"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "progress-bar-area"
}
const _hoisted_4 = {
  key: 0,
  class: "progress-step-info"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "progress-bar-animated" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

import { ProgressState } from "@medapro-types/common/components/ProgressHandling";
import { ProgressData } from "@medapro-types/common/components/ProgressModal";
import { computed } from "vue";
import Alert from "./Alert.vue";
import SpinnerBar from "./SpinnerBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    styling: { default: "generic" },
    size: { default: "sm" },
    progress: {},
    alwaysShow: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;



const showProgressBar = computed(() => {
  return props.progress?.state === ProgressState.Ongoing || props.alwaysShow;
});

const hasError = computed(() => {
  return props.progress?.state === ProgressState.Error;
});

const showLabel = computed(() => {
  return props.progress.withLabel ?? false;
});

const progressBarClasses = computed(() => {
  return [props.size];
});

return (_ctx: any,_cache: any) => {
  const _component_b_progress_bar = _resolveComponent("b-progress-bar")!
  const _component_b_progress = _resolveComponent("b-progress")!

  return (props.styling === 'generic' && props.progress)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (showLabel.value && props.progress.message)
          ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
              _createElementVNode("span", {
                class: _normalizeClass({ 'font-weight-bold': props.progress.state !== _unref(ProgressState).Finished })
              }, _toDisplayString(props.progress.message), 3)
            ]))
          : _createCommentVNode("", true),
        (props.progress.isIndeterminate)
          ? _withDirectives((_openBlock(), _createBlock(SpinnerBar, {
              key: 1,
              "animation-on": showProgressBar.value,
              class: "mb-3",
              size: props.size
            }, null, 8, ["animation-on", "size"])), [
              [_vShow, showProgressBar.value]
            ])
          : _createCommentVNode("", true),
        (!props.progress.isIndeterminate)
          ? _withDirectives((_openBlock(), _createBlock(_component_b_progress, {
              key: 2,
              class: _normalizeClass(["my-1 progress-bar-determinate", progressBarClasses.value]),
              max: props.progress.max
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_progress_bar, {
                  value: props.progress.value
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["class", "max"])), [
              [_vShow, showProgressBar.value]
            ])
          : _createCommentVNode("", true),
        (hasError.value)
          ? (_openBlock(), _createBlock(Alert, {
              key: 3,
              show: "",
              variant: "danger"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(props.progress.errorMessage), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        (showLabel.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.progress.message), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["progress-container", progressBarClasses.value])
        }, _hoisted_6, 2)
      ]))
}
}

})